import * as actionTypes from "../actionTypes"

export const setInboxMessagesAction = (inboxMessages: InboxMessages) => (dispatch: DispatchType) => {
  const action: InboxMessagesAction = {
    type: actionTypes.SET_INBOX_MESSAGES,
    inboxMessages,
  }
  dispatch(action)
}
